/**
 * Classify an exercise as compound or isolation using a name-pattern heuristic.
 *
 * We don't yet store a compound/isolation flag on the exercise schema, but the
 * user's profile has separate rest defaults for each category. This helper
 * returns `true` for the canonical compound lifts and presses; everything else
 * is treated as isolation (matching the "small muscle, shorter rest" intent).
 *
 * Word boundaries (\b) avoid false positives like "press-down" or "pulley row"
 * — `\brow\b` matches "Barbell row" but not "Power row machine".
 */
const COMPOUND_PATTERNS = [
    /\bsquat\b/i,
    /\bdeadlift\b/i,
    /\bbench\b/i,
    /\bpress\b/i,
    /\brow\b/i,
    /\bpull[- ]?up\b/i,
    /\bchin[- ]?up\b/i,
    /\bdip\b/i,
    /\bclean\b/i,
    /\bsnatch\b/i,
    /\blunge\b/i,
    /\bthrust\b/i,
];

export function isCompoundExercise(ex) {
    if (!ex) return false;
    const name = String(ex.name || '');
    return COMPOUND_PATTERNS.some((re) => re.test(name));
}

/** Pick the user's preferred rest based on exercise category. */
export function restForExercise(ex, prefs) {
    const p = prefs || {};
    return isCompoundExercise(ex)
        ? p.rest_compound_seconds || 120
        : p.rest_isolation_seconds || 60;
}
